import { render, staticRenderFns } from "./dragFormTableLayout.vue?vue&type=template&id=9119af32&"
import script from "./dragFormTableLayout.vue?vue&type=script&lang=js&"
export * from "./dragFormTableLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports